export const DATE_FORMAT = "DD/MM/YYYY";
export const TIME_FORMAT = "HH:mm:ss";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const DB_DATE_FORMAT = "YYYY-MM-DD";

export const TIMESTAMP_FORMAT = `${DATE_FORMAT}T${TIME_FORMAT}Z.SSS`;
